<template>
    <form-login></form-login>
</template>
<script>
import FormLogin from '@/components/FormLogin.vue'
export default {
    components : {
        FormLogin
    }
}
</script>
<style lang="scss" scoped>

</style>
